import React from "react";
import { Form } from "react-bootstrap";
import { TTimeOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import FormError from "../../../FormError";
import TimeSelector from "../../../TimeSelector";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TTimeOption;
}

const TimeField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="time">
      <Form.Label>Forecast runs</Form.Label>
      <TimeSelector
        spec={spec}
        values={formik.values.time}
        onChange={values => formik.setFieldValue('time', values.sort())}
      />

      <FormError
        message={formik.errors.time as TFormErrorMessage}
        when={formik.touched.time && Boolean(formik.errors.time)}
      />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default TimeField;
